module.exports = "<template>\n    <a class=\"back-to-top\" click.trigger=\"click()\">\n        <i class=\"${ iconClass }\"></i>\n    </a>\n</template>";